import Button from "src/components/Button";
import Modal from "src/components/Modal/Modal";
import { AtsJob } from "src/types/merge_ats";
import Import from "src/assets/images/generic/import2.png";
import useImportJob from "../hooks/useImportJob";

interface IImportJobModal {
  job: AtsJob;
  open: boolean;
  onClose: () => void;
}

const ImportJobModal = ({ job, open, onClose }: IImportJobModal) => {
  const { name } = job;
  const { importJob } = useImportJob();
  return (
    <Modal
      open={open}
      onChange={onClose}
      className="!w-[500px] flex flex-col items-center justify-center gap-6 text-center"
    >
      <p className="text-xl font-semibold ">Import {name && `"${name}"`}</p>

      <img src={Import} className="w-[138px] h-[112px]" />

      <p className="text-base leading-9">
        Once imported, this job will appear under the 'Active Jobs' tab in the 'Interviews' section.
        You can manage it from there.
      </p>

      <Button shapeVariant={2} onClick={() => importJob(job)}>
        Import Now
      </Button>
    </Modal>
  );
};

export default ImportJobModal;
